import axios from "axios";
import { profile } from "@/services/profile";

const state = {
  profile: {
    id: null,
    token: null,
    name: null,
    phone: null,
    categories: [],
    email: null,
    birthday_date: "",
    phone_code: "",
    phone_code_iso2: "",
    sex: null,
    dni: null,
    dni_type: null
  },
  session: { id: "" },
  allow_gps: false,
  location: {
    supplier_id: null
  },
  place: { place_id: null },
  supplierAvailability: { selected: false, data: {} },
  locationGhost: {
    supplier_id: null
  }
};

const getters = {
  profile: state => {
    return state.profile;
  },
  profile_id: state => {
    return state.profile.id;
  },
  profile_token: state => {
    return state.profile.token;
  },
  session_id: state => {
    return state.session.id;
  },

};

const actions = {
  async CreateProfileAnonymous({ commit }, data) {
    const response = await profile.CreateProfileAnonymous(data.domain, data.name);
    setTimeout(() => commit("profile/SetProfile", response.data, { root: true }), 1000);
  },
  InitSession({ commit, state, rootState }) {
    try {
      if (state.session.id === null || state.session.id === "") {
        const data = {
          customer_id: rootState.customer.instance.id,
          so: window.navigator.platform,
          browser: window.navigator.vendor,
          pixel_width: window.innerWidth,
          pixel_height: window.innerHeight
        };
        axios({
          method: "post",
          url: `${process.env.VUE_APP_API_CLUVIMKT}/api/sessions.json`,
          data: data
        }).then(
          response => {
            commit("profile/setSession", response.data, { root: true });
            if(window.hj !== undefined) window.hj("identify", response.data.id, {});
          },
          error => {
            error;
          }
        );
      } else {
        if(window.hj !== undefined) window.hj("identify", state.session.id, {});
      }
    } catch (error) {
      (error);
      axios({
        method: "post",
        url: `${process.env.VUE_APP_API_CLUVIMKT}/api/sessions.json`,
        data: {}
      }).then(
        response => {
          commit("profile/setSession", response.data, { root: true });
          if(window.hj !== undefined) window.hj("identify", response.data.id, {});
        },
        error => {
          error;
        }
      );
    }
  },
};

const mutations = {
  SetProfile(state, data) {
    if (data.id) {
      state.profile.id = data.id;
    }
    if (data.token) {
      state.profile.token = data.token;
    }
    if (data.name) {
      state.profile.name = data.name;
    }
    if (data.phone) {
      state.profile.phone = data.phone;
    }
    if (data.categories) {
      state.profile.categories = data.categories;
    }
    if (data.email) {
      state.profile.email = data.email;
    }
    if (data.birthday_date) {
      state.profile.birthday_date = data.birthday_date;
    }
    if (data.phone_code) {
      state.profile.phone_code = data.phone_code;
    }
    if (data.phone_code_iso2) {
      state.profile.phone_code_iso2 = data.phone_code_iso2;
    }
  },
  setSession(state, data) {
    state.session = data;
  },
  setAllowGps(state, data) {
    state.allow_gps = data;
  },
  setLocation(state, data) {
    state.location = data;
  },
  setPlace(state, data) {
    state.place = data;
  },
  setSupplierAvailability(state, data) {
    state.supplierAvailability = data;
  },
  setLocationGhost (state,data) {
    state.locationGhost = data;
  }
};

export default {
  preserveState: true,
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
